import type { IncomingMessage } from 'http';

import { graphql } from '@/graphql/__generated/gql';
import { prefetchRequest, useRequest } from '@/utils/request';

export type Region = {
    region: string;
    regionMatches: (region: string) => boolean;
};

const cacheKey = 'region';
const query = graphql(/* GraphQL */ `
    query GetRegion {
        region {
            locale
            region
        }
    }
`);

const useRegion = () => {
    const { data, isLoading, isError } = useRequest({
        cacheKey,
        query,
        appName: 'app-shell',
    });

    const locale = data?.region?.locale?.toLowerCase() ?? 'en-us';
    const region = data?.region?.region?.toLowerCase() ?? 'us';

    // TODO: Logic that changes the app based on the region should be handled in a more flexible configuration file instead of hardcoding it here
    const regionMatches: Region['regionMatches'] = (r) => {
        return r === region;
    };

    return {
        locale,
        region,
        regionMatches,
        isLoading,
        isError,
    };
};

// Used with getServerSideProps
const prefetchRegion = (req: IncomingMessage) => {
    return prefetchRequest({
        cacheKey,
        query,
        appName: 'app-shell',
        req,
    });
};

export { useRegion as default, prefetchRegion };
